import React, {useState} from "react";
import Navbar from "../Navbar";
import Sidebar from "../Sidebar";
import Footer from "../Footer";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

const NewCategory = () => {

  return (
    <>
    <div className="container-scroller">
        <Navbar />
        <div className="container-fluid page-body-wrapper" style={{paddingRight:"0px", paddingLeft:"0px"}}>
          <Sidebar />

          <div className="main-panel">
            <div className="content-wrapper">
              <div className="row">
                <div className="col-12 grid-margin stretch-card">
                  <div className="card">
                    <div className="card-body">
                        Add New Product 
                        <form>
                        <div className="mb-3 mt-3">
                            <label for="formFileSm" className="form-label">Choose Image</label>
                            <input className="form-control form-control-sm" id="formFileSm" type="file" />
                        </div>
                        {/* Product name and Everything */}
                        <div className="row g-2">
                            <div className="col-4">
                            <label for="exampleInputEmail1" className="form-label">Category Name:</label>
                            <input type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />
                            </div>
                            <div className="col-3">
                            <label for="exampleInputEmail1" className="form-label">Price per Unit:</label>
                            <input type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />
                            </div>
                            <div className="col-3">
                            <label for="exampleInputEmail1" className="form-label">Category Discount Price:</label>
                            <input type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />
                            </div>

                            <div className="col-2">
                            <div>
                            <label for="units">Units</label>
                            </div>
                            
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1"/>
                                <label className="form-check-label" for="flexRadioDefault1">
                                    Gram
                                </label>
                                </div>
                                <div className="form-check">
                                <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" />
                                <label className="form-check-label" for="flexRadioDefault2">
                                    Packets/piece
                                </label>
                                </div>
                        </div>
                        </div>

                    {/* Description of product */}
                        <div className="col-12">
                        <div className="mb-3 mt-2">
                            <label for="exampleFormControlTextarea1" className="form-label">Category Details</label>
                            <textarea className="form-control" id="exampleFormControlTextarea1" rows="7" style={{height:"20px"}}></textarea>
                        </div>  
                        </div>

                        {/* Submit */}
                        <div>
                        <button type="button" className="btn btn-outline-danger btn-icon-text col-12">
                          <i className="ti-upload btn-icon-prepend"></i>                                                    
                          Add to Database
                        </button>
                        </div>
                        </form>

                    </div>
                    </div>
                </div>
                </div>
            </div>
            </div>

        </div>
    <Footer />
    </div>
    </>
  )
}

export default NewCategory
